import * as t from "io-ts";
import { Pence } from "./Pence";

export const InfoStats = t.intersection([
  t.type({
    jobs_sent: t.number,
    jobs_applied_for_finance: t.number,
    jobs_approved_for_finance: t.number,
    jobs_total_revenue_of_approved: Pence,
    jobs_approval_rate: Pence,
    jobs_average_value_of_approved: Pence,
  }),
  t.partial({
    id: t.string,
  }),
]);

export interface InfoStats {
  id?: string;
  jobs_sent: number;
  jobs_applied_for_finance: number;
  jobs_approved_for_finance: number;
  jobs_total_revenue_of_approved: Pence;
  jobs_approval_rate: Pence;
  jobs_average_value_of_approved: Pence;
}
